import { MouseEvent as ReactMouseEvent } from 'react';
import styled, { css } from 'styled-components';

import { breakpoint } from 'app/theme/theme';
import { fileUploader } from 'app/translations/dictionary';

interface OpenUploaderLinkProps {
  onClick?: (event: ReactMouseEvent<HTMLElement, MouseEvent>) => void;
  disabled: boolean;
}

const Container = styled.span<{ $isLoading: boolean }>`
  font-size: 1.6rem;
  margin: 0;
  padding: 0;
  text-align: center;

  & button {
    color: ${({ theme }) => theme.palette.primary};
    text-decoration: underline;
    background-color: transparent;
    border: none;
    box-shadow: none;
    cursor: pointer;
  }

  ${({ theme, $isLoading }) =>
    $isLoading &&
    css`
      color: ${theme.palette.gray.silverChalice};

      & button {
        cursor: default;
        color: ${theme.palette.gray.silverChalice};
      }
    `}

  ${breakpoint.up.md`
    font-size: 2rem;
  `}
`;

export const OpenUploaderLink = ({ disabled, onClick }: OpenUploaderLinkProps): JSX.Element => (
  <Container $isLoading={disabled}>
    {fileUploader.openUploader.drop}{' '}
    <button disabled={disabled} type="button" onClick={onClick}>
      {fileUploader.openUploader.clickHere}
    </button>{' '}
    {fileUploader.openUploader.upload}
  </Container>
);
